'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = topicStore;

var _debounce = require('lodash/debounce');

var _debounce2 = _interopRequireDefault(_debounce);

var _filter = require('lodash/fp/filter');

var _filter2 = _interopRequireDefault(_filter);

var _forEach = require('lodash/fp/forEach');

var _forEach2 = _interopRequireDefault(_forEach);

var _storeRegistry = require('./storeRegistry');

var _storeRegistry2 = _interopRequireDefault(_storeRegistry);

var _prepareSelectorSets = require('../utils/prepareSelectorSets');

var _prepareSelectorSets2 = _interopRequireDefault(_prepareSelectorSets);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Max for single subscription request
 */
var TOPICS_PER_SELECTOR_SET = 31 * 1024;
var SUBSCRIPTION_CLOSE_DELAY = 200;

function flow(actions) {
    return function (value) {
        return actions.reduce(function (args, action) {
            return action(args);
        }, value);
    };
}

var getSubscribedTopics = function getSubscribedTopics(subscribed) {
    return (0, _filter2.default)(function (topic) {
        return !subscribed.get(topic);
    });
};

function subscriber() {
    var subscribedTopics = new Map();
    var currentSession = void 0;
    var stores = (0, _storeRegistry2.default)();

    var closeInactiveTopics = (0, _debounce2.default)(function () {
        stores.closeEmptyStores();
        var topicsUse = stores.getUsedTopics();
        subscribedTopics.forEach(function (isSubscribed, topic) {
            if (isSubscribed && topicsUse.indexOf(topic) < 0) {
                subscribedTopics.set(topic, false);
                if (currentSession && typeof currentSession.unsubscribe === 'function') {
                    currentSession.unsubscribe(topic);
                }
            }
        });
    }, SUBSCRIPTION_CLOSE_DELAY);

    stores.setCloseListener(closeInactiveTopics);

    var subscribeForTopics = flow([function (topics) {
        if (topics.length === 1) {
            return topics;
        }
        return (0, _prepareSelectorSets2.default)(topics, TOPICS_PER_SELECTOR_SET);
    }, (0, _forEach2.default)(function (topic) {
        currentSession.subscribe(topic).on('subscribe', function (details, subTopic) {
            subscribedTopics.set(subTopic, true);
        });
    })]);

    var subscribeTopics = flow([getSubscribedTopics(subscribedTopics), function (topics) {
        if (topics.length > 0) {
            subscribeForTopics(topics);
        }
    }]);

    var subscribe = function subscribe(topics) {
        var subscriptions = topics.map(stores.createStream);
        if (currentSession) {
            subscribeTopics(topics);
        }
        return subscriptions;
    };

    var setSession = function setSession(session) {
        currentSession = session;
        stores.setSession(session);
        if (currentSession) {
            subscribeTopics(stores.getTopics());
        }
    };

    return {
        subscribe: subscribe,
        setSession: setSession
    };
}

function topicStore() {
    var state = {};
    return Object.assign({}, subscriber(state));
}


//////////////////
// WEBPACK FOOTER
// ./~/rp-diffusion-connector/lib/connector/topicStore.js
// module id = 1761
// module chunks = 1